import { Icon, IconSize, Spinner } from '@bechtel/gds';
import { OutboundStatus } from '@bechtel/ht-types';

export function useTableHeaders() {
  const tableHeaders = [
    {
      id: 'Entity Type',
      label: 'Entity Type',
      key: 'outboundAction',
    },
    {
      id: 'Identifier',
      label: 'Identifier',
      key: 'identifier.0',
    },
    {
      id: 'Status',
      label: 'Status',
      key: 'status',
    },
    { id: 'Error Type', label: 'Error Type', key: 'errorType' },
    {
      id: 'Error Summary',
      label: 'Response/Error',
      key: 'response',
    },
    {
      id: 'Paylod',
      label: 'Payload',
      key: 'message',
    },
    {
      id: 'Created At',
      label: `Created At`,
      key: 'createdDate',
    },
    {
      id: 'id',
      label: `Outbound Interface ID`,
      key: 'id',
    },

    {
      id: 'Action',
      label: `Action`,
      key: 'action',
      render({ loading, onSync, status }) {
        return loading ? (
          <Spinner />
        ) : (
          <Icon
            iconStyle="solid"
            size={IconSize.MEDIUM}
            icon={status == OutboundStatus.SUCCESS ? 'check' : 'rotate'}
            fillColor={status == OutboundStatus.SUCCESS ? 'green.500' : 'bechtel.blue.800'}
            onClick={() => onSync()}
          />
        );
      },
    },
  ];
  return tableHeaders;
}

export const getFontColor = (outboundStatus: string) => {
  switch (outboundStatus) {
    case OutboundStatus.SUCCESS:
      return 'green.500';
      break;
    case OutboundStatus.ERROR:
      return 'red.500';
      break;
    default:
      return 'grey.1000';
      break;
  }
};
